<div class="switch-media-container">
  <div class="switch-media-block">
    <mat-button-toggle-group class="toggle-media-type-group toggle-action-type" [disabled]="disabled" [value]="selectedValue" hideSingleSelectionIndicator>
      @for (button of buttonsData; track button) {
        <mat-button-toggle (change)="toggleChange($event.value)" value="{{button.value}}">{{button.text}}</mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
</div>